import { render, staticRenderFns } from "./eventsDefinition.vue?vue&type=template&id=f2eb5fe4&"
import script from "./eventsDefinition.vue?vue&type=script&lang=js&"
export * from "./eventsDefinition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports